import {
  cardTitle,
  grayColor,
} from "assets/jss/material-dashboard-pro-react.js";

const userProfileStyles = {
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400",
    },
  },
  cardCategory: {
    marginTop: "10px",
    color: grayColor[0] + " !important",
    textAlign: "center",
  },
  description: {
    color: grayColor[0],
  },
  cardMain: {
    padding: 30,
  },
  fieldTitle: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    cardTitle,
    fontSize: 15,
    color: grayColor[0],
  },
  separata: {
    backgroundColor: "#d9d9d9",
    height: 1,
    width: "100%",
    borderRadius: "10%",
  },
  userInfo:{
    cardTitle,
    fontSize: 16,
    marginLeft: 10,
    marginTop: 5,
    marginBottom: 30,
  },
  icon: {
    color: "#51b1b9",
  },
  iconCircle: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    backgroundColor: "#51b1b9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
};
export default userProfileStyles;
